// authConfig.ts
import { Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { getRuntimeConfig } from "./runtimeConfig";

const getMsalConfig = (): Configuration => {
  try {
    const rc = getRuntimeConfig();
    return {
      auth: {
        clientId: rc.msalClientId,
        authority: rc.msalAuthority,
        redirectUri: rc.msalRedirectUri,
        postLogoutRedirectUri: rc.msalPostLogoutRedirectUri,
        navigateToLoginRequestUrl: false, //Terk Amendment 20260816 : prevent MSAL from restoring/compounding a stale or malformed pre-login path (e.g. /QuickAdd/QuickAdd 404), always return to the bare redirectUri
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    };
  } catch {
    // Fallback for dev / before runtime config is loaded
    return {
      auth: {
        clientId: "a0d7f00e-cab6-4106-844a-d41a63914fe4",
        authority:
          "https://login.microsoftonline.com/fe9c4641-3b53-43d0-af72-8f3e64d3aa05",
        redirectUri: "https://eecstg.dksh.com",
        postLogoutRedirectUri: "https://eecstg.dksh.com",
        navigateToLoginRequestUrl: false, //Terk Amendment 20260816 : prevent MSAL from restoring/compounding a stale or malformed pre-login path (e.g. /QuickAdd/QuickAdd 404), always return to the bare redirectUri
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    };
  }
};

export const loginRequest = {
  scopes: [
    "openid",
    "profile",
  ],
};

let msalInstance: PublicClientApplication | undefined;

export function initMsalInstance(): PublicClientApplication {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(getMsalConfig());
  }
  return msalInstance;
}


